tenderView.controller('bidModalCtrl', function (
    $scope,
    $uibModalInstance,
    $uibModal,
    tenderBidService,
    tenderService,
    exchangeService,
    agreementInstanceService,
    currencyListService,
    $stateParams,
    $rootScope,
    data,
    $state,
    ntFlash,
    documentsService,
    $timeout,
    $window
) {
    $scope.procurementMethodType = data.currentTender.data.procurementMethodType;
    // console.log(data.currentTender);
    $scope.isEsco = $scope.procurementMethodType === 'esco';
    $scope.isComplexAssetArma = $scope.procurementMethodType === 'complexAsset.arma';
    if (!$scope.isEsco && !$scope.isComplexAssetArma) {
        $scope.maxAmount = data.currentTender.data.value.amount;
        $scope.currency = data.currentTender.data.value.currency;
        var valueAddedTaxIncluded = data.currentTender.data.value.valueAddedTaxIncluded;
    }
    if($scope.isComplexAssetArma) {
        $scope.maxAmount = data.currentTender.data.minimalStep;
    }
    $scope.isAgreementClose = $scope.procurementMethodType === 'closeFrameworkAgreementSelectionUA';

    $scope.tender = data.currentTender.data;
    $scope.signerInfo = ($window.OPC_CONFIG.PROCURING_ENTITY.signerInfo) ?
        $window.OPC_CONFIG.PROCURING_ENTITY.signerInfo :
        {
        name: $window.OPC_CONFIG.PROCURING_ENTITY.name,
        email: $window.OPC_CONFIG.PROCURING_ENTITY.contactPoint.email,
        position: '',
        telephone: $window.OPC_CONFIG.PROCURING_ENTITY.contactPoint.telephone,
        authorizedBy: '',
        iban: '',
    }
    $scope.config = data.config;
    $scope.currencies = currencyListService.getCurrenciesList();
    $scope.tenderCdbId = $stateParams.id;
    $scope.isCancel = data.isCancel;
    $scope.subcontractingDetails = data.currentBid ? data.currentBid.subcontractingDetails : '';
    $scope.bidAmount = data.bidAmount ? Number(data.bidAmount) : "";
    $scope.bidPlaced = false;
    $scope.bidItems = $scope.tender.items;
    $scope.isBidProposal = tenderService.isCompetitiveDialogue(data.currentTender.data);
    $scope.changeMode = (data.bidAmount || ($scope.isBidProposal && data.currentBid)) ? true : false;
    if($scope.isEsco){
        $scope.changeMode = (data.currentBid) ? true : false;
    }

    $scope.agree = {
        value: false,
        selfEligible: false,
        selfQualified: false
    };
    $scope.qualityIndicator = {
        total: 0,
        totalPrice: $scope.bidAmount
    };

    exchangeService.getExchangeRate({
            tender_id: $scope.tender.id
        })
        .then(function (result) {
            $scope.exchangeRates = result.response;
        })
        .catch((err) => {
            let value = $scope.tender.value ? $scope.tender.value.currency : $scope.tender.lotValue ? $scope.tender.lotValue.value.currency : '';
            if (value !== 'UAH') {
                ntFlash.error(gettext('Курс валют НБУ наразі недоступний, спробуйте пізнише'), err.data);
            }
        });


    $scope.procurementMethodType = data.currentTender.data.procurementMethodType;
    $scope.features = data.currentTender.data.features || [];
    $scope.items = data.currentTender.data.items || [];
    $scope.lots = data.currentTender.data.lots || [];

    if ($scope.isAgreementClose) {
        $scope.agree = true;
        $scope.selfEligible = true;
        $scope.selfQualified = true;

        const currentAgreement = data.currentTender.data.agreements[0];

        const agreementId = currentAgreement.id;
        // const tenderId = currentAgreement.tender_id;
        const tenderId = $scope.tenderCdbId;

        agreementInstanceService.getContracts(tenderId, agreementId, 'only_users').then((res) => {
            let lotsArray = [];

            if (res.data.response[0]) {
                $scope.maxAgreementAmount = res.data.response[0].value.amount;
                $scope.maxAgreementAmountCurrency = res.data.response[0].value.currency;
            }

            res.data.response.map((elC) => {
                elC.parameters.map((elP) => {
                     data.currentTender.data.features.map((elF) => {
                        if(elP.code == elF.code){
                            elF.enum.map((elE) => {
                                if(elE.value == elP.value){
                                    lotsArray.push(elE);
                                }
                            });
                        }
                     });
                });
            });
            $scope.bidDataParameters = res.data.response[0].parameters;
            $scope.features = lotsArray;
            if ($scope.lots.length && $scope.features.length) {
                $scope.lots.forEach(function (lot) {
                    lot.qualityIndicator = 0;
                    $scope.features.forEach(function (feature) {
                        lot.qualityIndicator += Number(feature.value);
                    });
                });
            }
        });
    }

    if (tenderService.isCompetitiveDialogue2Stage(data.currentTender.data)) {
        let bidToLots = data.currentTender.action.can_create_bid_to_lots || [];
        $scope.lots = $scope.lots.filter(lot => bidToLots.indexOf(lot.id) > -1);
    }

    $scope.lots.forEach(function (lot, index) {
        lot.pricePerUnitIndex = index;
        lot.procurementMethodType = $scope.procurementMethodType;
        lot.items = $scope.tender.items.filter((item) => {
            return item.relatedLot === lot.id;
        });

        if ($scope.isEsco) {
            lot.calcYears = [];
            lot.value = {};
            lot.value.annualCostsReduction = Array(21);
            lot.value.annualCostsReduction.fill(0);
        }
    });

    $scope.isMultilotTender = $scope.lots.length ? true : false;

    if ($scope.isEsco && !$scope.isMultilotTender) {
        $scope.value = data.value ? data.value : {};
        $scope.value.yearlyPaymentsPercentage = data.value && data.value.yearlyPaymentsPercentage ? Number(data.value.yearlyPaymentsPercentageRange) : "";
        $scope.value.contractDuration = data.value && data.value.contractDuration ? Number(data.value.contractDuration) : {};
    }

    $scope.features.forEach(function (feature) {
        if (feature.featureOf === "lot") {
            feature.relatedLot = feature.relatedItem;
        } else if (feature.featureOf === "item") {
            $scope.items.forEach(function (item) {
                if (feature.relatedItem === item.id) {
                    feature.relatedLot = item.relatedLot;
                }
            });
        } else {
            feature.relatedLot = "tenderer";
        }
    });

    // console.log("Current Bid: ", data.currentBid);


    var currentTender = data.currentTender,
        calculatePercentage = function () {

            // console.log('$scope.features',$scope.features);

            $scope.qualityIndicator.total = 0;

            $scope.features.forEach(function (feature) {
                if (feature.selectedValue) {
                    $scope.qualityIndicator.total += feature.selectedValue;
                }
            });

            if ($scope.lots.length && $scope.features.length) {
                $scope.lots.forEach(function (lot) {
                    lot.qualityIndicator = 0;
                    $scope.features.forEach(function (feature) {
                        if (feature.selectedValue && (feature.featureOf == "tenderer" || feature.relatedLot == lot.id)) {
                            lot.qualityIndicator += Number(feature.selectedValue);
                        } else if ($scope.isAgreementClose) {
                            lot.qualityIndicator += Number(feature.value);
                        }
                    });
                });
            }

        };

    calculatePercentage();

    if (data.currentBid && !$scope.isMultilotTender) {
        if ($scope.isEsco) {
            $scope.value.yearlyPaymentsPercentage = data.currentBid.value.yearlyPaymentsPercentage ? +(data.currentBid.value.yearlyPaymentsPercentage * 100).toFixed(3) : "";
            $scope.value.contractDuration = data.currentBid.value.contractDuration ? data.currentBid.value.contractDuration : {
                years: 0,
                days: 0
            };
            $scope.value.annualCostsReduction = data.currentBid.value.annualCostsReduction ? data.currentBid.value.annualCostsReduction : [];
        }
    }
    if (data.currentBid) {
        if(data.currentBid.tenderers[0].signerInfo) {
            $scope.signerInfo = data.currentBid.tenderers[0].signerInfo;
        }
        if (data.currentBid.parameters && data.currentBid.parameters.length) {
            $scope.features.forEach(function (feature) {
                data.currentBid.parameters.forEach(function (param) {
                    if (feature.code === param.code) {
                        feature.enum.forEach(function (option) {
                            if (param.value == option.value) {
                                feature.selectedTitle = option.title;
                                feature.selectedValue = option.value;
                            }
                        });
                    }
                });
            });
        }
        if (data.currentBid.lotValues && data.currentBid.lotValues.length) {

            $scope.lots.forEach(function (lot) {
                data.currentBid.lotValues.forEach(function (lotValue) {
                    if (lotValue.relatedLot == lot.id) {
                        $scope.bidAdded = true;
                        lot.lotValue = {};
                        if (lotValue.value && lotValue.value.currency) {
                            lot.lotValue.currency = lotValue.value.currency;
                            lot.lotValue.amount = lotValue.value.amount;
                            if ($scope.isEsco) {
                                lot.value.yearlyPaymentsPercentage = lotValue.value.yearlyPaymentsPercentage * 100;
                                lot.value.contractDuration = lotValue.value.contractDuration;
                                lot.value.annualCostsReduction = lotValue.value.annualCostsReduction;
                            }
                        }
                        lot.lotValue.subcontractingDetails = lotValue.subcontractingDetails || '';
                    }
                });
            });
        }
        calculatePercentage();
    }

    $scope.totalMaxFeaturesVal = (function (features) {
        if (features && features.length) {
            var total = 0;
            features.forEach(function (feature) {
                var optionMaxVal = 0;
                feature.enum.forEach(function (option) {
                    optionMaxVal = Number(option.value) > optionMaxVal ? Number(option.value) : optionMaxVal;
                });
                total += optionMaxVal;
            });
            return total;
        } else {
            return 0;
        }
    })($scope.features);

    if ($scope.lots.length && $scope.features.length) {
        $scope.lots.forEach(function (lot) {
            lot.totalMaxFeaturesVal = 0;
            $scope.features.forEach(function (feature) {
                if (feature.featureOf == "tenderer" || feature.relatedLot == lot.id) {
                    var optionMaxVal = 0;
                    feature.enum.forEach(function (option) {
                        optionMaxVal = Number(option.value) > optionMaxVal ? Number(option.value) : optionMaxVal;
                    });
                    lot.totalMaxFeaturesVal += optionMaxVal;
                }
            });
        });
    }

    $scope.calculateTotalPrice = function (lot) {
        var coefficient = 1,
            totalSelectedVal = 0;

        if ($scope.features && $scope.features.length) {
            $scope.features.forEach(function (feature) {
                if (feature.selectedValue) {
                    totalSelectedVal += Number(feature.selectedValue);
                }
            });

            $scope.lots.forEach(function (lot) {
                lot.coefficient = 1 + lot.qualityIndicator / (1 - lot.totalMaxFeaturesVal);

                lot.totalPrice = $scope.bidAmountForm.$valid && lot.lotValue ?
                    Number(lot.lotValue.amount / lot.coefficient).toFixed(2) + ' ' + $scope.currency :
                    gettext('Ставка не корректна');
            });
        }

        coefficient += totalSelectedVal / (1 - $scope.totalMaxFeaturesVal);

        if ($scope.lots.length) {
            return !$scope.isEsco ? lot.totalPrice : "ESCO";
        }

        if (!$scope.isEsco) {
            return $scope.bidAmountForm.amount.$valid ?
                Number($scope.bidAmount / coefficient).toFixed(2) + ' ' + $scope.currency :
                gettext('Ставка не корректна');
        } else {
            return 'ESCO';
        }
    };

    $scope.shouldAddPricePerUnit = () => {
        return ($scope.tender.mainProcurementCategory === 'goods' || $scope.tender.contractTemplateName || $scope.tender.funders) &&
            !['competitiveDialogueUA.stage1', 'complexAsset.arma', 'competitiveDialogueEU.stage1', 'closeFrameworkAgreementUA', 'esco'].includes($scope.tender.procurementMethodType);
    };

    const getLotCurrency = function (lot) {
        return lot && lot.lotValue && lot.lotValue.currency ? lot.lotValue.currency :
            lot && lot.value && lot.value.currency ? lot.value.currency :
            $scope.currency;
    };

    const findCurrentBidItem = function (item) {
        if (!data.currentBid || !data.currentBid.items) {
            return null;
        }

        return data.currentBid.items.find(function (currentBidItem) {
            return currentBidItem.id === item.id;
        });
    };

    const setPricePerUnitValue = function (item, currency) {
        const currentBidItem = findCurrentBidItem(item);
        const currentBidUnitValue = currentBidItem && currentBidItem.unit ? currentBidItem.unit.value : null;
        const itemUnitValue = item.unit && item.unit.value ? item.unit.value : {};

        item.unit = item.unit || {};
        item.unit.value = {
            currency: currentBidUnitValue && currentBidUnitValue.currency ? currentBidUnitValue.currency : currency,
            amount: currentBidUnitValue && typeof currentBidUnitValue.amount !== 'undefined' ? currentBidUnitValue.amount :
                typeof itemUnitValue.amount !== 'undefined' ? itemUnitValue.amount : '',
            valueAddedTaxIncluded: false
        };
    };

    const initPricePerUnitItems = function () {
        if (!$scope.shouldAddPricePerUnit()) {
            return;
        }

        if ($scope.isMultilotTender) {
            $scope.lots.forEach(function (lot) {
                lot.items.forEach(function (item) {
                    setPricePerUnitValue(item, getLotCurrency(lot));
                });
            });
        } else {
            $scope.items.forEach(function (item) {
                setPricePerUnitValue(item, $scope.currency);
            });
        }
    };

    const getPricePerUnitBidValue = function (lot) {
        if (lot) {
            return {
                amount: lot.lotValue ? lot.lotValue.amount : null,
                currency: getLotCurrency(lot),
                valueAddedTaxIncluded: lot.value ? lot.value.valueAddedTaxIncluded : false
            };
        }

        return {
            amount: $scope.bidAmount,
            currency: $scope.currency,
            valueAddedTaxIncluded: valueAddedTaxIncluded
        };
    };

    const normalizePricePerUnitItems = function (items, currency) {
        items.forEach(function (item) {
            item.unit = item.unit || {};
            item.unit.value = item.unit.value || {};
            item.unit.value.currency = currency;
            item.unit.value.valueAddedTaxIncluded = false;
        });
    };

    const getPricePerUnitItems = function (lot) {
        return lot ? lot.items : $scope.items;
    };

    const getAmountInCents = function (amount) {
        return Math.round((Number(amount) || 0) * 100);
    };

    const roundAmount = function (amount) {
        return getAmountInCents(amount) / 100;
    };

    $scope.getCurrentPrice = (amount = 0, quantity = 0) => {
        return Number(quantity * amount).toFixed(2);
    };

    $scope.getPricePerUnitTotal = function (lot) {
        let quantityPrice = 0;
        getPricePerUnitItems(lot).forEach(function (item) {
            quantityPrice += Number(item.quantity || 0) * Number(item.unit && item.unit.value ? item.unit.value.amount : 0);
        });

        return roundAmount(quantityPrice);
    };

    $scope.getPricePerUnitCurrency = function (lot) {
        const bidValue = getPricePerUnitBidValue(lot);
        normalizePricePerUnitItems(getPricePerUnitItems(lot), bidValue.currency);
        return bidValue.currency;
    };

    $scope.isPricePerUnitValid = function (lot) {
        if (!$scope.shouldAddPricePerUnit()) {
            return true;
        }

        const bidValue = getPricePerUnitBidValue(lot);
        const items = getPricePerUnitItems(lot);

        if (!bidValue.amount || !bidValue.currency || !items.length) {
            return true;
        }

        normalizePricePerUnitItems(items, bidValue.currency);

        const hasAllPrices = items.every(function (item) {
            return item.unit && item.unit.value && item.unit.value.amount !== '' && typeof item.unit.value.amount !== 'undefined' && item.unit.value.currency === bidValue.currency && item.unit.value.valueAddedTaxIncluded === false;
        });

        if (!hasAllPrices) {
            return true;
        }

        const itemsTotal = getAmountInCents($scope.getPricePerUnitTotal(lot));
        const bidAmount = getAmountInCents(bidValue.amount);
        if (bidValue.valueAddedTaxIncluded) {
            return itemsTotal >= getAmountInCents(Number(bidValue.amount) / 1.2) && itemsTotal <= bidAmount;
        }

        return itemsTotal === bidAmount;
    };

    $scope.checkPricePerUnit = function (form, lot) {
        if (!form || !$scope.shouldAddPricePerUnit()) {
            return;
        }

        const isValid = $scope.isPricePerUnitValid(lot);
        const lotIndex = lot ? lot.pricePerUnitIndex : null;

        getPricePerUnitItems(lot).forEach(function (item, index) {
            const fieldName = lot ? 'price_per_unit_' + lotIndex + '_' + index : 'price_per_unit_' + index;
            if (form[fieldName]) {
                form[fieldName].$setValidity('pricePerUnitTotal', isValid);
            }
        });
    };

    const checkAllPricePerUnit = function () {
        if (!$scope.shouldAddPricePerUnit()) {
            return;
        }

        if ($scope.isMultilotTender) {
            $scope.lots.forEach(function (lot) {
                if (lot.lotValue) {
                    $scope.checkPricePerUnit($scope.bidAmountForm, lot);
                }
            });
        } else {
            $scope.checkPricePerUnit($scope.bidAmountForm);
        }
    };

    const getBidItemsForPricePerUnit = function (items, bidValue) {
        return items.map(function (item) {
            const unit = angular.copy(item.unit);
            unit.value = {
                amount: item.unit.value.amount,
                currency: bidValue.currency,
                valueAddedTaxIncluded: false
            };

            return {
                description: item.description,
                id: item.id,
                quantity: item.quantity,
                relatedLot: item.relatedLot,
                unit: unit
            };
        });
    };

    initPricePerUnitItems();

    $scope.selectDropdown = function (item, feature) {
        feature.selectedValue = item.value;
        feature.selectedTitle = item.title;
        calculatePercentage();
    };

    $scope.showBid = function (lot, check) {
        $timeout(() => {
            $scope.lots[lot].lotValue = {
                currency: getLotCurrency($scope.lots[lot])
            };
            if ($scope.shouldAddPricePerUnit()) {
                normalizePricePerUnitItems($scope.lots[lot].items, getLotCurrency($scope.lots[lot]));
            }
        }, 200);
        $scope.bidAdded = true;
    };

    $scope.showTenderAmount = (tender) => {
        const tenderDate = new Date(tender.date);
        const dayAfterChange = new Date(    '2026-06-07T00:00:00Z')
        return tenderDate > dayAfterChange
    }

    $scope.getMaxAmount = function (lot){
        if(($scope.procurementMethodType === 'aboveThreshold' || $scope.procurementMethodType === 'competitiveOrdering') && $scope.config.hasValueRestriction === false){
            return '99999999999999'
        } else {
            return lot
        }

    }

    $scope.hideBid = function (lot) {
        $timeout(() => {
            delete $scope.lots[lot].lotValue;
        }, 200);
        if ($scope.features) {
            $scope.features.forEach(function (feature) {
                if (feature.hasOwnProperty("selectedValue") && feature.relatedLot == $scope.lots[lot].id) {
                    delete feature.selectedValue;
                }
            });
        }
    };

    $scope.placeBid = function () {
        var bidData = $scope.prepareBid(true);
        console.log(bidData)
        if ($scope.isMultilotTender && !bidData.lotValues.length) {
            ntFlash.error(gettext('У багатолотовій закупівлі має бути хоча б одна пропозиція'));
            return;
        }

        checkAllPricePerUnit();
        if ($scope.bidAmountForm.$valid && $scope.agree) {
            $scope.bidPlaced = true;
            tenderBidService.save($scope.tenderCdbId, bidData)
                .then(function (data) {

                    $uibModalInstance.close(data);
                }, function (err) {
                    console.log(err);
                    $scope.bidPlaced = false;
                    if (err && err.data && err.data.errors && err.data.errors[0] === 'Low balance') {
                        ntFlash.error(gettext('Недостаточно средств на счету'));
                    }
                });
        }
    };

    $scope.changeBid = function () {

        var bidData = $scope.prepareBid();

        if ($scope.isMultilotTender && !bidData.lotValues.length) {
            ntFlash.error(gettext('У багатолотовій закупівлі має бути хоча б одна пропозиція'));
            return;
        }
        checkAllPricePerUnit();
        if ($scope.bidAmountForm.$valid) {
            tenderBidService
                .edit(currentTender.data.cdb_id, data.currentBid.id, bidData)
                .then((data) => $uibModalInstance.close());
        }
    };

    $scope.prepareBid = function (isCreate) {
        var bidData = {
            value: {
                currency: $scope.currency,
                amount: $scope.isBidProposal ? 0 : $scope.bidAmount,
                valueAddedTaxIncluded: valueAddedTaxIncluded
            },
            parameters: [],
            lotValues: [],
            agree: $scope.agree.value
        };

        if($scope.procurementMethodType == "competitiveDialogueUA" || $scope.procurementMethodType == "competitiveDialogueEU"){

            delete bidData.parameters
        }
        if($scope.tender.contractTemplateName) {
            bidData.tenderers = [{
                signerInfo : $scope.signerInfo
            }]
        }



        if ( isCreate) {
            if($scope.procurementMethodType !== "belowThreshold" && $scope.procurementMethodType !=='requestForProposal'){
                bidData.selfEligible = $scope.agree.selfEligible;
                bidData.selfQualified = $scope.agree.selfQualified;
            } else {
                delete bidData.selfQualified
            }
        }
        if($scope.procurementMethodType === 'complexAsset.arma'){
            delete bidData.selfEligible
        }





        if ($scope.tender.criteria && isCreate) delete bidData.selfEligible;

        if ($scope.procurementMethodType !== "belowThreshold" && !$scope.isMultilotTender) {
            bidData.subcontractingDetails = $scope.subcontractingDetails;
        }

        if ($scope.features) {
            $scope.features.forEach(function (feature) {
                if (feature.hasOwnProperty("selectedValue")) {
                    bidData.parameters.push({
                        code: feature.code,
                        value: feature.selectedValue
                    });
                }
            });
        }

        if ($scope.isEsco && !$scope.isMultilotTender) {
            delete bidData.value.amount;
            bidData.value.contractDuration = $scope.value.contractDuration;
            bidData.value.yearlyPaymentsPercentage = $scope.value.yearlyPaymentsPercentage / 100;
            bidData.value.annualCostsReduction = $scope.value.annualCostsReduction;
        }

        if ($scope.shouldAddPricePerUnit() && !$scope.isMultilotTender) {
            normalizePricePerUnitItems($scope.items, bidData.value.currency);
            bidData.items = getBidItemsForPricePerUnit($scope.items, bidData.value);
        }

        if ($scope.isMultilotTender) {
            delete bidData.value;
            $scope.lots.forEach(function (lot) {
                if (lot.lotValue) {
                    var lotValue = {
                        relatedLot: lot.id
                    };
                    if (!$scope.isEsco && !$scope.isComplexAssetArma) {
                        lotValue.value = {
                            amount: $scope.isBidProposal ? 0 : lot.lotValue.amount,
                            currency: getLotCurrency(lot),
                            valueAddedTaxIncluded: lot.value.valueAddedTaxIncluded
                        };
                    }
                    if ($scope.isComplexAssetArma) {
                        lotValue.value = {
                            amountPercentage: lot.lotValue.amountPercentage,
                        };
                    }
                    if ($scope.shouldAddPricePerUnit() && lotValue.value) {
                        normalizePricePerUnitItems(lot.items, lotValue.value.currency);
                        const items = getBidItemsForPricePerUnit(lot.items, lotValue.value);
                        bidData.items = bidData.items ? bidData.items.concat(items) : items;
                    } else {
                        const items = $scope.tender.items.filter((item) => {
                            return item.relatedLot === lot.id;
                        })
                        if(bidData.items){
                            items.forEach((item) => {
                                bidData.items.push({
                                    description : item.description,
                                    id: item.id,
                                    quantity: item.quantity,
                                    relatedLot: item.relatedLot,
                                    unit: item.unit,
                                })
                            })
                        } else {
                            bidData.items = items.map((item) => {
                                if(item.unit && item.unit.value){
                                    item.unit =   {
                                        ...item.unit,
                                        value: {
                                            ...item.unit.value,
                                            valueAddedTaxIncluded: lot.value.valueAddedTaxIncluded
                                        }
                                    }
                                }
                                return {
                                    description : item.description,
                                    id: item.id,
                                    quantity: item.quantity,
                                    relatedLot: item.relatedLot,
                                    unit: item.unit,
                                }
                            })
                    }
                        }


                    if($scope.procurementMethodType == "competitiveDialogueUA" || $scope.procurementMethodType == "competitiveDialogueEU"){
                        delete lotValue.value
                    }
                    if ($scope.isEsco) {
                        lotValue.value = {
                            contractDuration: {
                                years: lot.value.contractDuration.years,
                                days: lot.value.contractDuration.days
                            },
                            // amount: 0,
                            yearlyPaymentsPercentage: lot.value.yearlyPaymentsPercentage / 100,
                            annualCostsReduction: lot.value.annualCostsReduction,

                            // Defaults for Esco ?
                            currency: 'UAH',
                            valueAddedTaxIncluded: true,
                        };
                    }
                    bidData.lotValues.push(lotValue);
                    bidData.lotValues[bidData.lotValues.length - 1].subcontractingDetails = lot.lotValue.subcontractingDetails;

                }
            });
        }
        // // TODO REmove for subcontractingDetails
        // if($scope.procurementMethodType === "belowThreshold"){
        //     const tempLotValues = [...bidData.lotValues]
        //     bidData.lotValues = []
        //     tempLotValues.forEach((el, index) => {
        //         delete el.subcontractingDetails
        //         bidData.lotValues.push(el)
        //     })
        // }
        // // TODO REmove for subcontractingDetails

        if($scope.isAgreementClose){
            bidData.parameters = $scope.bidDataParameters;
        }
        return bidData;
    };

    $scope.cancelBid = function () {
        tenderBidService
            .delete(currentTender.data.cdb_id, data.currentBid.id)
            .then(() => {
                $scope.changeMode = false;
                $uibModalInstance.close();
            });
    };

    $scope.close = function () {
        $uibModalInstance.dismiss();
    };
});
